import type { CSSProperties, ReactNode } from 'react';
import './GlassCard.css';

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'light';
  style?: CSSProperties;
  onClick?: () => void;
}

/**
 * GlassCard — reusable glassmorphic container.
 *
 * Ported from rptv-main's inline glass patterns. Consistent blur, border,
 * and radius across all showcase screens.
 */
export default function GlassCard({
  children,
  className = '',
  variant = 'default',
  style,
  onClick,
}: GlassCardProps) {
  const variantClass = variant === 'light' ? 'glass-card--light' : '';

  return (
    <div
      className={`glass-card ${variantClass} ${className}`.trim()}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
